<template>
  <el-dialog
    :visible.sync="show"
    append-to-body="true"
    destroy-on-close
    title="编辑司机结算信息"
    width="540px"
    @close="handClose"
  >
    <div class="settleShow">
      <nf-tips-only :title="bankTips" class="margin-t-5 margin-b-15" />
      <el-form ref="form" :model="form" :rules="rules" label-width="140px">
        <el-form-item label="银行卡号：" prop="bankCard">
          <!-- <el-input
            v-model="form.bankCard"
            placeholder="请输入银行卡号"
            size="small"
            @input="handInput(form.bankCard)"
          /> -->
          <el-input v-model="form.bankCard" placeholder="请输入银行卡号" size="small" />
        </el-form-item>
        <el-form-item label="开户行总行 ：" prop="supBank">
          <nf-select
            v-model="form.supBank"
            :change="selectBankNameBySup"
            :response-transform-fn="bankNameFnBySup"
            :search-params="{ searchKey: 'bankName' }"
            api-url="/rest/common/bank/getBankBySupBankName"
            methods-fn="get"
            placeholder="请输入开户行总行，支持模糊匹配"
          />
        </el-form-item>
        <!-- <el-form-item label="开户行支行：" prop="bank">
          <nf-select
            v-model="form.bank"
            :change="selectBankName"
            :response-transform-fn="bankNameFn"
            :search-params="{ searchKey: 'bankName' }"
            api-url="/rest/openAccount/findBankCodeLikeName"
            methods-fn="get"
            placeholder="请输入开户行，支持模糊匹配"
          />
        </el-form-item> -->
        <el-form-item label="银行预留手机：" prop="bankCardPhone">
          <el-input v-model="form.bankCardPhone" placeholder="请输入银行预留手机号" size="small" />
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handClose"> 取 消 </el-button>
      <el-button size="small" type="primary" @click="handShow"> 确 定 </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { bankCardTreeVerification, getBankByCard } from '@/api/captain';
import NfTipsOnly from '@/components/nf-tips-only';
import { validaItePhone, validaIteNoPhone, validateCardNo } from './rules';

export default {
  components: {
    NfTipsOnly,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: [Function, Object],
      default: () => {},
    },
    info: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      banKList: [],
      form: {
        bank: '',
        bankCard: '',
        supBank: '',
        bankCardPhone: '',
      },

      rules: {
        bank: [{ required: false, message: '请输入开户行支行', trigger: ['blur', 'change'] }],
        supBank: [{ required: true, message: '请输入开户行总行', trigger: ['blur', 'change'] }],
        bankCard: [{ required: true, validator: validateCardNo, trigger: ['blur', 'change'] }],
        bankCardPhone: [
          { required: false, validator: validaIteNoPhone, trigger: ['blur', 'change'] },
        ],
      },
    };
  },
  computed: {
    bankTips() {
      return this.$store.state.tips.bankTips;
    },
  },
  watch: {
    data: {
      handler(val) {
        this.data = val;
        for (const valKey in this.form) {
          this.form[valKey] = val[valKey];
        }
      },
      deep: true,
    },
    info: {
      handler(val) {
        if (val) {
          this.rules.bankCardPhone[0].required = true;
          this.rules.bankCardPhone[0].validator = validaItePhone;
        } else {
          this.rules.bankCardPhone[0].required = false;
          this.rules.bankCardPhone[0].validator = validaIteNoPhone;
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.info = this.$props.info;
    if (this.info) {
      this.rules.bankCardPhone[0].required = true;
      this.rules.bankCardPhone[0].validator = validaItePhone;
    } else {
      this.rules.bankCardPhone[0].required = false;
      this.rules.bankCardPhone[0].validator = validaIteNoPhone;
    }
  },
  methods: {
    bankNameFn(list, setOptionsFn) {
      setOptionsFn(
        list.map(({ bankName }) => {
          return {
            value: bankName,
            label: bankName,
          };
        }),
      );
    },
    bankNameFnBySup(list, setOptionsFn) {
      setOptionsFn(
        list.map(bankName => {
          return {
            value: bankName,
            label: bankName,
          };
        }),
      );
    },
    selectBankName(item) {
      if (item && item.label) {
        this.form.bank = item.label && item.label;
      }
    },
    // 开户行总行
    selectBankNameBySup(item) {
      if (item && item.label) {
        this.form.supBank = item.label && item.label;
      }
    },
    handleBank(val) {
      this.form.supBank = this.info.supBank;
    },
    //回填开户行总行
    async handInput(val) {
      let str = '';
      if (!this.form.supBank) {
        if (val && val.length && (val.length > 5 || val.length == 5)) {
          if (val.length > 14 || val.length == 14) {
            str = Number(val.replace(/\\/g, '/'));
          } else {
            str = Number(val.replace(/\\/g, '/').slice(0, 6));
          }
          const res = await getBankByCard({
            bankCard: str,
          });
          this.form.supBank = res.data.bankName;
        }
      }
    },
    handClose() {
      for (const valKey in this.form) {
        this.form[valKey] = this.data[valKey];
      }
      this.$emit('handClose');
    },
    handShow() {
      let res = {};
      const _this = this;
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.info = Object.assign({}, this.info, this.form);
          res = await bankCardTreeVerification({
            bankCard: _this.form.bankCard,
            name: _this.info.name,
            idCard: _this.info.identityNumber,
          });
          if (res.code == 200 && res.data) {
            _this.$emit('handShow', this.info);
          } else {
            _this.$$message('姓名、身份证号、银行卡号不匹配，请检查信息是否有误', 'error');
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
.settleShow {
  .el-input {
    width: 350px !important;
  }

  .el-form-item__label {
    display: inline-block !important;
    line-height: 32px !important;
  }

  .el-select-dropdown__item.selected {
    color: #181818 !important;
    font-weight: 400 !important;
  }
}
</style>
<style scoped>
.settleShow {
  margin-top: -10px;
}
</style>
